var plugin_rtlignore_default = {
  "alignLeft": "_3wl4x",
  "textWrapNowrap": "uEAeL",
  "alignRight": "c42YG",
  "alignCenter": "MjaZV",
  "sizeFullWidth": "wF6Wp",
  "renderedInTable": "PosPL",
  "sizeOriginal": "eLKFM",
  "sizeContent": "d77zP",
  "sizeSmall": "d1Z5b",
  "sizeSmallCenter": "H5zHO",
  "flex": "fUZlZ",
  "atomic": "_5PBMS",
  "embed": "t2USV",
  "horizontalScrollbar": "Fndl8",
  "pluginContainerMobile": "aUGlZ"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
